<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <main>
      <div class="flex gap-x-2">
        <question-mark size="h-16 w-16" />
        <div>
          <h3 class="text-fg-default text-xl font-semibold">
            Guide & Instruction
          </h3>
          <p class="font-light text-sm" style="word-break: normal">
            To make a bulk payment, please follow the steps below:
          </p>
        </div>
      </div>
      <ol
        class="font-light lg:text-sm text-xs mt-5 list-decimal list-inside text-fg-default"
      >
        <li class="py-3 leading-loose">
          Select Payout currency, the currency selected will be the currency you
          want to out in.
        </li>
        <li class="py-3 leading-loose">
          The payout amount is debited from your holding account in the same
          currency you chose.
        </li>
        <li class="py-3 leading-loose">
          Select preferred beneficiary type(Single or multiple)
        </li>
        <li class="py-3 leading-loose">
          Select payment method (Mobile money or Bank transfer)
        </li>
        <li class="py-3 leading-loose">
          Download the CSV template, for multiple beneficiaries. Choose from
          your saved beneficiaries or add a new one for a single beneficiary
        </li>
        <li class="py-3 leading-loose">
          Select payout frequency (One time payout or Recurring payout)
        </li>
        <li class="py-3 leading-loose">
          Fill in the beneficiary list for multiple beneficiaries, save it and
          upload it.
        </li>
        <li class="py-3 leading-loose">
          Enter a descriptive payout name to identify the transaction.
        </li>
      </ol>
      <el-button
        @click="handleClose"
        class="w-full bg-primary text-white rounded-lg shadow-xs py-4 font-light"
        >I understand</el-button
      >
    </main>
  </el-dialog>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'StartWireTransfer',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  components: {
    QuestionMark: () => import('@/assets/v2/icons/QuestionMark.vue')
  },
  data () {
    return {
      breakpoints,
      transferReason: ''
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
li {
  word-break: normal;
}
.slide-fade-enter-active {
  animation: slide-fade 0.3s ease forwards;
}
.slide-fade-leave-active {
  animation: slide-fade 0.3s ease forwards alternate-reverse;
}

@media screen and (max-width: 768px) {
  * >>> .el-radio__label {
    font-size: 12px;
  }
}
* >>> .el-dialog {
  border-radius: 0.5rem !important;
}
* >>> .el-radio__inner {
  height: 1.2rem;
  width: 1.2rem;
  border: 2px solid #bdbdbd;
}
@media screen and (min-width: 1280px) {
  * >>> .el-dialog {
    margin-right: 28vw;
  }
}
@media screen and (min-width: 1680px) {
  * >>> .el-dialog {
    margin-right: 29vw;
  }
}
</style>
